import React, { useState } from 'react';

import { useDataProvider } from 'leeloo-react/component/hook/useDataProvider';

import { DataTableDefaultButton } from './DataTableDefaultButton';
import { DataTableButtonType } from '../../../model/dataTable/DataTableButtonType';

export function DataTableArchiveButton<T>(props: DataTableButtonType<T>) {
    const [isLoad, setIsLoad] = useState(false);
    const dp = useDataProvider();

    const fetchPromise = () => dp.update!(props.resource, { id: props.row?.id });
    const fetchPromises = () => (props.rows as []).map((row: T & {id: any}) => dp.update!(props.resource, { id: row.id }));

    return (
        <DataTableDefaultButton
            {...props}
            isLoad={isLoad}
            onClick={() => setIsLoad(true)}
            label="Archiver"
            icon="uil uil-file-export"
            fetchPromise={fetchPromise}
            fetchPromises={fetchPromises}
            handleLoad={setIsLoad}
            messageFetchOne="Confirmez-vous l'archivage de cet élément ?"
            messageFetchMultiples="Confirmez-vous l'archivage de ces éléments ?"
            messageSuccess="Archivage effectué avec succès"
        />
    );
}

DataTableArchiveButton.defaultProps = {
    variant: 'primary',
};
